import React from 'react';
import axios from 'axios';
// import * as Sentry from '@sentry/react';
import { Modal, ModalHeader, ModalContent, ModalFooter, ModalAction } from '@components/ModalComponents';
import { toast } from 'react-toastify';
import { useUser } from '@store';
import { useRemovePaymentMethodMutation } from '../queries/removePaymentMethod.mutation.generated';

interface MethodRemoveModalProps {
  open: boolean;
  onClose: () => void;
  methodInput: any;
  refetch: () => void;
}

////////// COMPONENT //////////
const MethodRemoveModal: React.FC<MethodRemoveModalProps> = (props: MethodRemoveModalProps) => {
  const { open, onClose, methodInput, refetch } = props;

  const [removePaymentMethod] = useRemovePaymentMethodMutation();
  const user = useUser();

  const handleSubmit = async () => {
    try{
      if (methodInput?.pending_setup_intent_id) {
        // Still waiting on Stripe's micro-deposits: the SetupIntent is canceled in Stripe too, or
        // Stripe keeps sending the deposits and a "verify your account" email for a method that no
        // longer exists here. The function retires the row as well.
        const token = await user?.getToken();
        await axios.post(
          '/.netlify/functions/cancelStripeBankSetup',
          { customerId: methodInput.customer_id, setupIntentId: methodInput.pending_setup_intent_id },
          { headers: { authorization: `Bearer ${token}` } }
        );
      } else {
        await removePaymentMethod({variables: {id: methodInput.id}});
      }
      refetch();
    }catch(err){
      toast.error(`Failed to remove payment method`);
      console.log(`Error removing payment method:`, err);
    };
    handleClose();
  };

  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
      <Modal open={open}>
        <ModalHeader handleClose={handleClose}>Remove Payment Method</ModalHeader>

        <ModalContent
          subtitle={`Are you sure you want to remove this payment method? (${methodInput && methodInput.name})`}
        />

        <ModalFooter>
          <ModalAction onClick={() => handleSubmit()}>Confirm</ModalAction>
          <ModalAction onClick={() => handleClose()} color='utility'>
            Cancel
          </ModalAction>
        </ModalFooter>
      </Modal>
  );
};

export default MethodRemoveModal;
